import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.Weather`]: `Weather`,
      [`${prefix}.Preparation.VaneDepth`]: `Vane Depth`,
      [`${prefix}.Preparation.HandShearVane`]: `Hand Shear Vane`,
      [`${prefix}.Preparation.CalibrationFactor`]: `Hand Shear Vane Factor`,
      [`${prefix}.Preparation.MaximumReading`]: `Hand Shear Vane Maximum Reading`,
      [`${prefix}.Preparation.BladeSize`]: `Hand Shear Vane Blade Size`,

      [`${prefix}.Measurements.ResultNotObtainable`]: `Result not obtainable`,
      [`${prefix}.Measurements.ResultNotObtainableReason`]: `Reason`,

      [`${prefix}.Measurements.Measurements.Reading`]: `Reading`,
      [`${prefix}.Measurements.Measurements.MaximumExceeded`]: `Maximum Exceeded`,
      [`${prefix}.Measurements.Measurements.VaneShearStrength`]: `Vane Shear Strength`,
      [`${prefix}.Measurements.Measurements.ResultNotObtainable`]: `Not Obtainable`,

      [`${prefix}.Results.AverageVaneShearStrengthText`]: `Average Vane Shear Strength`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.CalibrationFactor`]: `kPa/div`,
      [`${prefix}.Preparation.MaximumReading`]: `divs`,
      [`${prefix}.Measurements.Measurements.Reading`]: `divs`,
      [`${prefix}.Results.AverageVaneShearStrengthText`]: `kPa`,
    })
  );

export default getLabelConfig;
